import { Injectable } from '@angular/core';
import Group from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import TileGrid from 'ol/tilegrid/TileGrid';
import TileWMS from 'ol/source/TileWMS';

@Injectable({
  providedIn: 'root'
})
export class SclMapViewsService {

  constructor() { }

  getMultiLayers(mapViews) {
    const layers = [];
    let existShow = false;
    for (let i = 0; i < mapViews.length; i++) {
      const mapView = mapViews[i];
      if (mapView.isShow) {
        existShow = true;
        break;
      }
    }
    for (let i = 0; i < mapViews.length; i++) {
      const mapView = mapViews[i];
      let isShow = false;
      if (mapView.isShow) { isShow = mapView.isShow; }
      if (!existShow && i === 0) {
        existShow = true;
        isShow = true;
      }
      let tile = null;
      if (mapView.groupView) {
        const listLayers = [];
        for (let j = 0; j < mapView.groupView.length; j++) {
          const view = mapView.groupView[j];
          const member = this.getTile(view, isShow);
          listLayers.push(member);
        }
        const option = {
          visible: isShow,
          title: mapView.uiLabel, // not support 6.15.1
          layers: listLayers
        };
        tile = new Group(option);
      } else {
        tile = this.getTile(mapView, isShow);
      }

      layers.push(tile);
    }
    return layers;
  }
  getTile(mapView, isShow) {
    let tile; tile = '';
    if (mapView.serverType === 'tile') {
      const optionOSM = {
        url: mapView.url,
        crossOrigin: mapView.crossOrigin,
        wrapDateLine: false,
        wrapX: false,
        noWrap: true
      };
      const optionTile = {
        title: mapView.uiLabel, // not support 6.15.1
        visible: isShow,
        source: new OSM(optionOSM),
      }
      tile = new TileLayer(optionTile);
    } else if (mapView.serverType === 'geoserver') {
      let tileGrid;
      if (mapView.extent) {
        tileGrid = new TileGrid({
          extent: mapView.extent,
          resolutions: mapView.resolutions,
          tileSize: mapView.tileSize
        });
      }
      const optionWMS = {
        url: mapView.url,
        params: mapView.params,
        projection: mapView.EPSG,
        serverType: mapView.serverType,
        tileGrid,
        wrapDateLine: false, // not support 6.15.1
        wrapX: false,
        noWrap: true // not support 6.15.1
      };
      const tileWMS = new TileWMS(optionWMS);

      const optionLayer = {
        title: mapView.uiLabel, // not support 6.15.1
        visible: isShow,
        source: tileWMS
      };
      tile = new TileLayer(optionLayer);
      if (mapView.extent) {
        tile.setExtent(mapView.extent);
      }
    }
    return tile;
  }
  createUIButton(document, action, classAction, title, text) {
    const button = document.createElement('BUTTON');
    button.setAttribute('class', classAction);
    button.setAttribute('title', title);
    button.addEventListener('click', action, false);
    if (text) { button.innerHTML = text; }
    const spanButton = document.createElement('SPAN');
    spanButton.setAttribute('role', 'tooltip');
    button.appendChild(spanButton);

    return button;
  }
  createCheckbox(document, name) {
    const checkbox = document.createElement('input');
    checkbox.setAttribute('type', 'checkbox');
    checkbox.setAttribute('id', name);
    return checkbox;
  }
  createRadio(document, title, visible, name) {
    const radio = document.createElement('input');
    radio.setAttribute('type', 'radio');
    radio.setAttribute('name', name);
    radio.setAttribute('id', title);
    if (visible) {
      radio.setAttribute('checked', 'checked');
    }
    return radio;
  }
  createLabel(document, name, innerHTML) {
    const label = document.createElement('label');
    label.setAttribute('for', name);
    if (innerHTML) { label.innerHTML = innerHTML; }
    return label;
  }
  addRadioButton(document, element, layers, compId) {
    layers.forEach(function(layer, i) {
      const title = layer.get('title');
      const radio = this.createRadio(document, compId + title, layer.getVisible(), compId);
      radio.onclick = function() {
        layers.forEach(function(layer, j) {
          let value = layer.get('title');
          if (!value || value === 'Vector') {
            return;
          }
          const newTil = compId + title;
          value = compId + value;
          if (value === newTil) {
            layer.setVisible(true);
            if (layer instanceof Group) {
              layer.getLayers().forEach(function(sublayer, k) {
                sublayer.setVisible(true);
              });
            }
          } else {
            layer.setVisible(false);
          }
        });
      },

        element.appendChild(radio);
      const label = this.createLabel(document, compId + title, title);
      element.appendChild(label);
    });
  }

}
